
<rad-accordion
    #accordion
    [attr.header]="formControl?.label"
    [attr.expanded]="formControl?.isOpen"
    [appShadowDom]="shadowDomConfig"
    >
    <div slot="content">
        <ng-container #formContainer></ng-container>
    </div>
</rad-accordion>